import { memo } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import MfaqInfoPanel from "@coworker/apprestructured/src/task-management/components/MfaqInfoPanel/MfaqInfoPanel";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

function MfaqInfoPanelDemo() {
  return (
    <Demo>
      <Name>MfaqInfoPanel</Name>
      <Highlight>
        <MfaqInfoPanel
          label="Upvotes"
          filterLabel="Last 4 weeks"
          upvotes={562}
          location="in Home Service Point - Planning studio"
        />
      </Highlight>
    </Demo>
  );
}

export default memo(MfaqInfoPanelDemo);
